(function () {
  if (window.__levivantSuspendedMatterLoaded) return;
  window.__levivantSuspendedMatterLoaded = true;

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initLayer(root) {
    if (!root || root.dataset.suspendedMatterReady || mobileQuery.matches || reduceMotionQuery.matches) return;

    var hero = root.closest('.hero');
    var canvas = root.querySelector('canvas');
    var context = canvas && canvas.getContext('2d');
    if (!hero || !context) return;

    root.dataset.suspendedMatterReady = 'true';

    var width = 1;
    var height = 1;
    var dpr = 1;
    var frame = 0;
    var time = 0;
    var cursor = { x: -10000, y: -10000, active: false, pressure: 0 };
    var requestedCount = Number(root.dataset.particleCount || 240);
    var count = Math.max(120, Math.min(360, requestedCount));
    var influenceRadius = Math.max(140, Math.min(300, Number(root.dataset.influenceRadius || 220)));
    var opacityScale = Math.max(0.2, Math.min(0.8, Number(root.dataset.opacity || 55) / 100));
    var particles = [];

    function resize() {
      var rect = root.getBoundingClientRect();
      width = Math.max(1, rect.width);
      height = Math.max(1, rect.height);
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      context.setTransform(dpr, 0, 0, dpr, 0, 0);

      particles.forEach(function (particle) {
        particle.baseX = particle.baseNX * width;
        particle.baseY = particle.baseNY * height;
        particle.x = Math.min(width, particle.x);
        particle.y = Math.min(height, particle.y);
      });
    }

    function createParticles() {
      particles = [];

      for (var index = 0; index < count; index += 1) {
        var baseNX = Math.random();
        var baseNY = Math.random();
        var depth = 0.35 + Math.random() * 0.65;
        if (Math.random() > 0.82) depth += 0.45;

        particles.push({
          baseNX: baseNX,
          baseNY: baseNY,
          baseX: baseNX * width,
          baseY: baseNY * height,
          x: baseNX * width,
          y: baseNY * height,
          vx: 0,
          vy: 0,
          delayedForceX: 0,
          delayedForceY: 0,
          phaseX: Math.random() * Math.PI * 2,
          phaseY: Math.random() * Math.PI * 2,
          driftSpeed: 0.00014 + Math.random() * 0.00026,
          driftRadiusX: 4 + Math.random() * 13,
          driftRadiusY: 3 + Math.random() * 10,
          sensitivity: 0.45 + Math.random() * 0.65,
          returnStrength: 0.00018 + Math.random() * 0.00032,
          damping: 0.94 + Math.random() * 0.025,
          size: Math.min(3.2, (0.85 + Math.random() * 1.65) * depth),
          alpha: Math.min(0.72, (0.24 + Math.random() * 0.46) * depth * opacityScale)
        });
      }
    }

    function handlePointerMove(event) {
      var rect = hero.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;

      cursor.active = x >= 0 && x <= rect.width && y >= 0 && y <= rect.height;
      if (!cursor.active) return;

      cursor.x = x;
      cursor.y = y;
      cursor.pressure = Math.min(1, cursor.pressure + 0.18);
    }

    function handlePointerLeave() {
      cursor.active = false;
    }

    function updateParticle(particle) {
      var flowX = particle.baseX + Math.sin(time * particle.driftSpeed + particle.phaseX) * particle.driftRadiusX;
      var flowY = particle.baseY + Math.cos(time * particle.driftSpeed * 0.82 + particle.phaseY) * particle.driftRadiusY;

      var returnX = (flowX - particle.x) * particle.returnStrength;
      var returnY = (flowY - particle.y) * particle.returnStrength;
      var targetForceX = 0;
      var targetForceY = 0;

      if (cursor.active || cursor.pressure > 0.01) {
        var deltaX = particle.x - cursor.x;
        var deltaY = particle.y - cursor.y;
        var distanceSquared = deltaX * deltaX + deltaY * deltaY;
        var radius = influenceRadius * particle.sensitivity;

        if (distanceSquared < radius * radius && distanceSquared > 0.01) {
          var distance = Math.sqrt(distanceSquared);
          var falloff = 1 - distance / radius;
          var eased = falloff * falloff * (3 - 2 * falloff);
          var force = eased * 0.055 * particle.sensitivity * cursor.pressure;
          targetForceX = (deltaX / distance) * force;
          targetForceY = (deltaY / distance) * force;
        }
      }

      particle.delayedForceX += (targetForceX - particle.delayedForceX) * 0.055;
      particle.delayedForceY += (targetForceY - particle.delayedForceY) * 0.055;
      particle.vx += returnX + particle.delayedForceX;
      particle.vy += returnY + particle.delayedForceY;
      particle.vx *= particle.damping;
      particle.vy *= particle.damping;
      particle.x += particle.vx;
      particle.y += particle.vy;
    }

    function render() {
      time += 16.67;
      context.clearRect(0, 0, width, height);

      cursor.pressure *= cursor.active ? 0.985 : 0.94;
      if (cursor.pressure < 0.002) cursor.pressure = 0;

      particles.forEach(function (particle) {
        updateParticle(particle);

        context.beginPath();
        context.fillStyle = 'rgba(232, 236, 237,' + particle.alpha.toFixed(3) + ')';
        context.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        context.fill();
      });

      frame = window.requestAnimationFrame(render);
    }

    var resizeObserver = new ResizeObserver(resize);

    resize();
    createParticles();
    resizeObserver.observe(root);
    window.addEventListener('pointermove', handlePointerMove, { passive: true });
    hero.addEventListener('pointerleave', handlePointerLeave, { passive: true });
    frame = window.requestAnimationFrame(render);

    root.addEventListener('suspended-matter:destroy', function () {
      resizeObserver.disconnect();
      window.cancelAnimationFrame(frame);
      window.removeEventListener('pointermove', handlePointerMove);
      hero.removeEventListener('pointerleave', handlePointerLeave);
    }, { once: true });
  }

  function init() {
    document.querySelectorAll('[data-suspended-matter]').forEach(initLayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-suspended-matter]').forEach(function (root) {
      root.dispatchEvent(new CustomEvent('suspended-matter:destroy'));
    });
  });
})();
